import { Requests } from './requests.js';
import { refreshCartUi, displayLoading } from './miniCartUiHelpers';

export class MiniCart {
  constructor() {
    this.cartRequests = new Requests();
  }

  loadCart() {
    displayLoading();

    if (this.cartRequests.isLoading()) {
      return Promise.resolve('loading');
    }

    return this.cartRequests.getCartContents().then(json_data => {
      refreshCartUi(json_data);
    });
  }

  deleteItem(item) {
    displayLoading();
    if (this.cartRequests.isLoading()) {
      return Promise.resolve('loading');
    }

    return this.cartRequests.deleteItem(item).then(json_data => {
      refreshCartUi(json_data);
    });
  }

  addItems(data_product_string) {
    displayLoading();

    if (this.cartRequests.isLoading()) {
      return Promise.resolve('loading');
    }

    let json_items = this.parseDataProduct(data_product_string);

    if (json_items[0] != null) {
      json_items[0].referrer = window.location.href;
    }

    return this.cartRequests.addItems(json_items).then(json_data => {
      refreshCartUi(json_data);
      // eslint-disable-next-line no-prototype-builtins
      if (json_data.hasOwnProperty('redirect')) {
        window.location.replace(json_data.redirect);
      }
    });
  }

  parseDataProduct(data_product_string) {
    let items = {};

    try {
      items = JSON.parse(data_product_string);
    } catch (e) {
      return items;
    }

    // eslint-disable-next-line no-prototype-builtins
    if (!items.hasOwnProperty('term')) {
      items.term = 2;
    }
    // TODO::Check quantity if enhanced

    return items;
  }
}
